<template>
  <div data-aos="fade" data-aos-delay="500" data-aos-duration="1500">
    <v-img :src="item.url" max-width="90" contain class="mx-auto"></v-img>
    <div class="pt-4">
      <h3 class="secondary--text title-font text-h6">
        {{ item.name }}
      </h3>
      <small class="secondary--text font-weight-bold d-block pb-3">
        {{ item.description }}
      </small>
      <p class="secondary--text body-font text-body-2 mb-0">
        {{ item.longDescription }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "IndividualService",
  props: {
    item: Object,
  },
};
</script>
<style scoped src="@/assets/css/home.css"></style>
<style scoped></style>
